import { Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { pageResolver } from './pages/page/page.resolver';

const createCaseInsensitiveMatcher =
  (routePattern: string) =>
  (segments: UrlSegment[]): UrlMatchResult | null => {
    const patternSegments = routePattern.split('/').filter(Boolean);

    if (segments.length < patternSegments.length) {
      return null;
    }

    const posParams: Record<string, UrlSegment> = {};

    for (let i = 0; i < patternSegments.length; i += 1) {
      const patternSegment = patternSegments[i];
      const currentSegment = segments[i];

      if (patternSegment.startsWith(':')) {
        posParams[patternSegment.slice(1)] = currentSegment;
        continue;
      }

      if (currentSegment.path.toLowerCase() !== patternSegment.toLowerCase()) {
        return null;
      }
    }

    return {
      consumed: segments.slice(0, patternSegments.length),
      posParams,
    };
  };

export const routes: Routes = [
  {
    path: 'time-booking',
    loadComponent: () =>
      import('./parts/booking/time-booking/time-booking.component').then(
        (m) => m.TimeBookingComponent,
      ),
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./pages/booking-profile/booking-profile.component').then(
        (m) => m.BookingProfileComponent,
      ),
  },
  {
    matcher: createCaseInsensitiveMatcher('pagetemplate/:id'),
    resolve: { page: pageResolver },
    runGuardsAndResolvers: 'always',
    loadComponent: () =>
      import('./pages/page/page.component').then((m) => m.PageComponent),
  },
  {
    matcher: createCaseInsensitiveMatcher('pagebyid/:id'),
    resolve: { page: pageResolver },
    runGuardsAndResolvers: 'always',
    loadComponent: () =>
      import('./pages/page/page.component').then((m) => m.PageComponent),
  },
  {
    path: '**',
    resolve: { page: pageResolver },
    runGuardsAndResolvers: 'always',
    loadComponent: () =>
      import('./pages/page/page.component').then((m) => m.PageComponent),
  },
];
